import React from 'react';
import { useIntl } from 'react-intl';

let intl;

const GlobalInternalizationProvider = ({ children }) => {
  intl = useIntl();
  return children;
};

export { intl };
export default GlobalInternalizationProvider;
